<div id="doctors-list" class="flex flex-col gap-3">
  <div class="flex justify-end">
    <button mat-flat-button (click)="openAddNew()">
      Add New Product
    </button>
  </div>
  <div id="doctors-list-header" class="flex flex-row justify-between">
    <p class="w-30">Image</p>
    <p class="flex-1 ml-3">Name</p>
    <p>Usage</p>
  </div>
  <mat-divider></mat-divider>
  <div class="body flex flex-col gap-3">
    @if (!!displayedProducts) {
      @for (product of displayedProducts; track product['id']) {
        <div class="custom-btn rounded-lg" (click)="openProduct(product)">
          <div class="flex flex-row justify-between p-3 cursor-pointer items-center">
            <img [src]="product.image_url" alt="" height="30px" width="auto">
            <p class="flex-1 ml-3">{{ product.name }}</p>
            <div class="flex flex-col">
              @for (item of product.application_time; track item) {
                <p>{{ mapApplicationTime[item-1] }}</p>
              }
            </div>
          </div>
        </div>
      }

      @if (hasMoreProducts) {
        <div class="flex justify-center mt-4">
          <button mat-flat-button color="primary" (click)="loadMoreProducts()">
            Load More
          </button>
        </div>
      }
    } @else {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
  </div>
</div>
